<template>
  <header
    class="header-container"
    :class="{ 'scrolled-nav': isScrolled, 'header-home': isHomePage }"
  >
    <div class="content header-content">
      <div class="branding">
        <router-link :to="{ name: 'home' }">
          <img
            id="logo"
            src="@/assets/logo/logo-juf-financeiro-white.svg"
            alt="JU Financeiro logo"
          />
        </router-link>
      </div>

      <nav class="navigation-items">
        <ItemsList />
        <LanguageSelector />
      </nav>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, defineOptions, computed } from 'vue'
import ItemsList from '@/components/Menu/ItemsList.vue'
import LanguageSelector from '@/components/Global/LanguageSelector.vue'
import router from '@/router'

defineOptions({
  name: 'HeaderComponent',
})

const isScrolled = ref(false)

const updateScroll = () => {
  isScrolled.value = window.scrollY > 50
}

onMounted(() => {
  window.addEventListener('scroll', updateScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', updateScroll)
})

const isHomePage = computed(() => {
  return router.currentRoute.value.name === 'home'
})
</script>

<style scoped>
.header-container {
  position: fixed;
  width: 100%;
  z-index: 900;
  background-color: var(--color-primary);
  padding: 10px 0;
  transition: background-color 0.3s ease, padding 0.3s ease;
}

.header-home {
  background-color: transparent;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;
}

.scrolled-nav {
  background-color: rgba(41, 119, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 8px 0;
  box-shadow: var(--shadow-sm);
}

.scrolled-nav #logo {
  width: 70px;
}

.branding #logo {
  display: block;
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100px;
  transition: width 0.3s ease;
}

.navigation-items {
  display: flex;
  align-items: center;
  gap: 5px;
}

.center-logo {
  justify-content: center;
}

.center-logo .branding {
  flex-grow: 1;
  text-align: center;
}

.center-logo .branding #logo {
  margin: 0 auto;
  width: 140px;
}

@media (max-width: 991px) {
  .branding #logo {
    width: 80px;
  }
}
</style>
